// extracted by mini-css-extract-plugin
export default {"list":"wqa2am1Hox1Fs3tbkhRz","toast":"TrywHTO3RQy31B4oOCIx","centerScreen":"wYnFLhb0QFpW5vTSSMcR","pulse":"RTx2P7QbZ1PEATgsXBi9"};